import { getData } from "./index.svc"

export const getContactsService = async (showAll = false) => {
  const qs = showAll ? '?all=1' : ''
  return await getData(`contacts${qs}`)
}

export const createContactService = async (body) => await getData('contacts', 'POST', body)

export const updateContactService = async (body) => await getData(`contacts/${body.ID}`, 'POST', body)

export const deleteContactService = async(id) => await getData(`contacts/${id}?Active=No`, 'DELETE')

export const resetContactService = async(id) => await getData(`contacts/${id}?Active=Yes`, 'DELETE')